<template>
  <sx-header />
  <slot />
  <sx-new-footer />
</template>
